import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const STORAGE_KEY = 'seop_month';

function readStored(): number {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw === null ? NaN : Number.parseInt(raw, 10);
    return Number.isInteger(parsed) && parsed >= 0 ? parsed : 0;
  } catch {
    return 0; // modo privado / storage bloqueado
  }
}

function persist(month: number): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(month));
  } catch {
    // sem storage, o mês continua valendo pela URL
  }
}

/**
 * Mês selecionado do módulo, guardado na **query string**.
 *
 * As rotas do repo são planas: cada `<Route>` monta um elemento novo, então o
 * `SeopLayout` remonta a cada troca de aba. Um `useState`/context dentro dele
 * perderia o mês na navegação — por isso `?mes=`, com o último valor espelhado no
 * `localStorage` para quem volta ao módulo por um link sem query.
 */
export function useSeopMonth(): { month: number; setMonth: (m: number) => void } {
  const [params, setParams] = useSearchParams();

  const raw = params.get('mes');
  const parsed = raw === null ? NaN : Number.parseInt(raw, 10);
  const month = Number.isInteger(parsed) && parsed >= 0 ? parsed : readStored();

  const setMonth = useCallback(
    (next: number) => {
      persist(next);
      const updated = new URLSearchParams(params);
      updated.set('mes', String(next));
      // `replace`: trocar de mês não deve empilhar histórico do navegador.
      setParams(updated, { replace: true });
    },
    [params, setParams],
  );

  return { month, setMonth };
}

export default useSeopMonth;
